import Dropzone from 'components/base/Dropzone';
import ProgressBar from 'components/common/ProgressBar/ProgressBar';
import IMerchProductOrderItem from 'models/restful/IMerchProductOrderItem';
import React from 'react';

interface UploadSectionProps {
  orderItem: IMerchProductOrderItem;
  showRequired: boolean;
  onUpload: (name: string, file: File) => void;
  mockupUploading: boolean;
  artworkUploading: boolean;
  mockupUploadProgress: number;
  artworkUploadProgress: number;
}

const UploadSection: React.FC<UploadSectionProps> = ({
  orderItem,
  showRequired,
  onUpload,
  mockupUploading,
  artworkUploading,
  mockupUploadProgress,
  artworkUploadProgress
}) => (
  <div className="upload-section">
    <div className="upload-section__grid">
      <div className="upload-section__column">
        <div
          className={`upload-section__item upload-section__item--reversed ${
            showRequired && !orderItem.Artwork ? 'is-invalid' : ''
          }`}
        >
          <div className="invalid-feedback">Please upload artwork</div>
          {artworkUploading && (
            <ProgressBar valuenow={artworkUploadProgress * 100} />
          )}
          <Dropzone
            accept={{
              'image/*': ['.png', '.jpeg', '.jpg']
            }}
            title="Artwork"
            canRemove={false}
            defaultImage={orderItem.Artwork?._props.thumb128}
            onDrop={acceptedFiles => {
              onUpload('Artwork', acceptedFiles[0]);
            }}
            className={`${
              showRequired && !orderItem.Artwork ? 'is-invalid' : ''
            }`}
          />
          <h4 className="upload-section__title">Artwork</h4>
        </div>
      </div>
      <div className="upload-section__column">
        <div className="upload-section__item upload-section__item--reversed">
          {mockupUploading && (
            <ProgressBar valuenow={mockupUploadProgress * 100} />
          )}
          <Dropzone
            accept={{
              'image/*': ['.png', '.jpeg', '.jpg']
            }}
            title="Mockup"
            canRemove={false}
            defaultImage={orderItem.Mockup?._props.thumb128}
            onDrop={acceptedFiles => {
              onUpload('Mockup', acceptedFiles[0]);
            }}
          />
          <h4 className="upload-section__title">Mockup</h4>
        </div>
      </div>
    </div>
  </div>
);

export default UploadSection;
